<template>
    <div id="app">
        <router-view></router-view>
    </div>
</template>

<script>
    export default {
        name: 'app',
    }
</script>
<style src="vue-material/dist/vue-material.css"></style>
<style src="sweetalert2/dist/sweetalert2.min.css"></style>
<style lang="stylus">
/* https://github.com/vuematerial/vue-material/issues/417 */
    input[type="color"],
    input[type="date"],
    input[type="datetime"],
    input[type="datetime-local"],
    input[type="email"],
    input[type="month"],
    input[type="number"],
    input[type="password"],
    input[type="search"],
    input[type="tel"],
    input[type="text"],
    input[type="time"],
    input[type="url"],
    input[type="week"],
    select:focus,
    textarea
        font-size 16px!important
    .md-select .md-select-value
        padding-right 16px
        line-height 35px
    .md-theme-default.md-input-container .md-icon:not(.md-icon-delete):after
        background none !important
    .datepickbox
        width 100%
        >input
            width 100%
    .display-time
        width 100% !important
    .clear-btn
        top -1em !important
    .vdp-datepicker
        input
            width 100%
            margin-top 0
            border none
            border-bottom 1px solid #ccc
            font-size 16px!important
    .md-input-container.md-input-disabled input.md-input, .md-input-container.md-input-disabled input.md-input.forcedisabled, .md-input-container.md-input-disabled div.md-select.forcedisabled .md-select-value
        color #2c4760!important
    @media (max-width: 700px)
        .free_disturb .md-button
            width 100% !important
            max-width 100% !important
            float none !important
            display block !important
        .free_disturb .md-dialog-actions
            display block !important
        .free_disturb  .md-button
            margin-left 0 !important
            margin-top 10px !important
</style>
<style lang="stylus">
    @import 'assets/styles/variables/color.styl'
    @import 'assets/styles/redesign.styl'
</style>



// WEBPACK FOOTER //
// App.vue?7ce17af4